import React from 'react';

import Layout from './../components/layout';
import SEO from '../components/seo';

const ContactPage = () => (
  <Layout withArchive>
    <SEO title="Kontakt" />
    <h1>Kontakt</h1>
    <p>Zapraszam do kontaktu poprzez serwis {` `}
    <a href="https://www.linkedin.com/in/slawomirzawistowski/"
        target="_blank" rel="noopener noreferrer">LinkedIn</a>
      {` `}lub bezpośrednio na maila:</p>
    
    <p><strong>zawistowski.slawomir@gmail.com</strong></p>
    
    <p>Posiadam również konto na portalu <a href="https://dlafirm.pracuj.pl/" target="_blank" rel="noopener noreferrer">pracuj.pl</a> (powinna być uaktywniona widoczność dla rekruterów).</p>

  </Layout>
)

export default ContactPage
